import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { loginStatusSelector } from '../../store/auth/auth.selectors';
import { Loader } from '../Routes.style';

const SmAuthWrapper = ({ children }: { children: ReactNode }) => {
  const loginStatus = useSelector(loginStatusSelector);

  if (loginStatus !== 'pending') {
    return <>{children}</>;
  }

  return <Loader dataTestId="loader-smauth" />;
};

export default SmAuthWrapper;
